<template>
  <div class="sidebar-header">
    <h1 class="logo" v-show="!isCollapsed">Kewaar</h1>
    <h1 class="logo mini-logo" v-show="isCollapsed">K</h1>
    <div class="header-controls">
      <button class="collapse-toggle" @click="$emit('toggle-collapse')" aria-label="Toggle Sidebar Size">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20 12H4" />
          <path d="M18 8l-4 4 4 4" v-if="isCollapsed" />
          <path d="M6 8l4 4-4 4" v-else />
        </svg>
      </button>
      <button class="mobile-close" @click="$emit('close-sidebar')" aria-label="Close Sidebar">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M18 6L6 18M6 6l12 12"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SidebarHeader',
  props: {
    isCollapsed: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle-collapse', 'close-sidebar']
}
</script>

<style scoped>
.sidebar-header {
  padding: 1.75rem 1.5rem;
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  padding-bottom: 1rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
  background-color: transparent;
}

.logo {
  font-size: 1.75rem;
  font-weight: 700;
  margin: 0;
  color: var(--sidebar-logo-color, #fff);
  letter-spacing: 0.5px;
}

.mini-logo {
  font-size: 1.5rem;
}

.header-controls {
  display: flex;
  align-items: center;
}

.collapse-toggle {
  background: rgba(255, 255, 255, 0.05);
  border: none;
  border-radius: 8px;
  padding: 0.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 0.5rem;
  transition: all 0.3s ease;
}

.collapse-toggle:hover {
  background: rgba(255, 255, 255, 0.1);
}

.collapse-toggle svg {
  width: 16px;
  height: 16px;
  color: rgba(255, 255, 255, 0.6);
}

.mobile-close {
  display: none;
  background: rgba(255, 255, 255, 0.05);
  border: none;
  border-radius: 8px;
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.3s ease;
}

.mobile-close svg {
  width: 20px;
  height: 20px;
  color: rgba(255, 255, 255, 0.6);
  transition: color 0.3s ease;
}

.mobile-close:hover {
  background: rgba(255, 255, 255, 0.1);
}

.mobile-close:hover svg {
  color: white;
}

:root[data-theme="light"] .sidebar-header {
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
  background-color: transparent;
}

:root[data-theme="light"] .logo {
  color: #111827;
}

:root[data-theme="light"] .collapse-toggle {
  background: rgba(0, 0, 0, 0.05);
}

:root[data-theme="light"] .collapse-toggle:hover {
  background: rgba(0, 0, 0, 0.08);
}

:root[data-theme="light"] .collapse-toggle svg {
  color: rgba(0, 0, 0, 0.6);
}

@media (max-width: 768px) {
  .mobile-close {
    display: flex;
  }
  
  .sidebar-header {
    padding: 1.25rem;
  }
}
</style> 